import React from 'react'
import { Descriptions } from 'antd'
import { Signer as SignerData } from '../../../../services/api/companies'

const { Item } = Descriptions
type Props = {
  signer: SignerData
}

export const Signer: React.FunctionComponent<Props> = ({ signer }) => {
  return (
    <Descriptions bordered column={1}>
      <Item label="Данные подписанта">
        <strong> {signer.position}: </strong>
        {signer.firstName} {signer.middleName} {signer.lastName}
      </Item>
    </Descriptions>
  )
}
